import React, { useRef, useState, useEffect } from "react";
import "./OTPForm.scss";
import OtpInput from "react-otp-input";
import Countdown from "react-countdown";
import CustomButton from "../../../../components/CustomButton/CustomButton";

interface OTPFormProps {
  email: string;
  onResendOtp: () => Promise<void>;
  onContinue?: (otp: string) => void;
  otpExpiredTime?: string;
  loading: boolean;
  invalidOtp: boolean;
}

const OTPForm: React.FC<OTPFormProps> = ({
  email,
  onResendOtp,
  onContinue,
  otpExpiredTime,
  loading,
  invalidOtp
}) => {
  const [otp, setOtp] = useState("");
  const [isResendAvailable, setIsResendAvailable] = useState(false);
  const [isOtpInvalid, setIsOtpInvalid] = useState(false)
  const timerKeyRef = useRef(
    otpExpiredTime ? new Date(otpExpiredTime).getTime() : Date.now()
  );
  const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
  const lastOtpLength = useRef(0);
  console.log(email, invalidOtp)
  useEffect(() => {
    console.log("Inside invalid otp:", isOtpInvalid)
    console.log("Come from another:", invalidOtp)
    setIsOtpInvalid(invalidOtp);

  }, [invalidOtp]);

  useEffect(() => {
    console.log("Resend OTP useEffect:", isResendAvailable)
  }, [isResendAvailable])

  useEffect(() => {
    setIsResendAvailable(false)
    if (otp.length < 6 && isOtpInvalid) {
      setIsOtpInvalid(false);
    }
    if (otp.length > 0 && otp.length < 6) {
      inputRefs.current[otp.length]?.focus();
    }
    lastOtpLength.current = otp.length;
    console.log("Inside otp change useEffect", isResendAvailable)
  }, [otp]);

  const renderer = ({
    minutes,
    seconds,
    completed,
  }: {
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      setIsResendAvailable(true)
      return null;
    } else {
      return (
        <div className="timer">
          {`
          ${minutes.toString().padStart(2, "0")}:${seconds
              .toString()
              .padStart(2, "0")}`}
        </div>
      );
    }
  };

  const handleButtonClick = async () => {
    setIsResendAvailable(false);
    if (isResendAvailable) {
      await onResendOtp();
      timerKeyRef.current = otpExpiredTime
        ? new Date(otpExpiredTime).getTime()
        : Date.now();
      setIsResendAvailable(false);
      setOtp("");
    } else {
      if (onContinue) onContinue(otp);
    }
  };

  const handleChange = (value: string) => {
    setOtp(value);
  };

  const handleKeyDown = (e: React.KeyboardEvent, index: number) => {
    const isNumberKey = /^[0-9]$/.test(e.key);
    const isNavigationKey = [
      'Backspace',
      'ArrowLeft',
      'ArrowRight',
      'Delete',
      'Tab'
    ].includes(e.key);

    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs.current[index - 1]?.focus();
    } else if (isNumberKey && index < 5 && otp.length === index + 1) {
      setTimeout(() => inputRefs.current[index + 1]?.focus(), 0);
    }

    if (!isNumberKey && !isNavigationKey && !e.ctrlKey) {
      e.preventDefault();
    }

    if (index === 5 && e.key === 'Enter' && otp.length === 6) {
      handleButtonClick();
    }
  };

  return (
    <div className="OTP-container">
      <div className="OTP-inner-container">
        <div className="OTP-verification">
          <div className="otp-title-container">
            <div className="header">OTP Verification</div>
            <div className="title-inner">
              <div className="title">We have sent a 6 digit verification code to</div>
              <div className="title">{email}</div>
            </div>
          </div>
          <div className="otp-input-container">
            <div className="otp-timer">
              <OtpInput
                value={otp}
                onChange={handleChange}
                numInputs={6}
                shouldAutoFocus
                containerStyle="otp-container"
                inputStyle={isOtpInvalid ? 'input-style input-error' : 'input-style'}
                renderInput={(props, index) => (
                  <input
                    {...props}
                    ref={(el) => {
                      inputRefs.current[index] = el;
                    }}
                    type="tel"
                    inputMode="numeric"
                    pattern="[0-9]*"
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    onPaste={(e) => {
                      e.preventDefault();
                      const pastedData = e.clipboardData
                        ?.getData("text/plain")
                        .replace(/\D/g, "");
                      if (pastedData?.length === 6) {
                        setOtp(pastedData);
                        inputRefs.current[5]?.focus();
                      }
                    }}
                  />
                )}
              />

              <div className="timer-container justify-between">
                <div
                  className={`otp-error ${isOtpInvalid && !isResendAvailable
                    ? 'justify-between'
                    : isOtpInvalid
                      ? 'justify-start'
                      : isResendAvailable
                        ? 'justify-end'
                        : 'justify-end'
                    }`}
                >
                  {isOtpInvalid && !isResendAvailable && (
                    <div className="resend-otp otp-invalid-error">Invalid OTP</div>
                  )}

                  {isResendAvailable ? (
                    <button className="not-a-button resend-otp" onClick={handleButtonClick}>
                      Resend OTP
                    </button>
                  ) : (
                    <Countdown
                      key={timerKeyRef.current}
                      date={timerKeyRef.current}
                      renderer={renderer}
                      onComplete={() => {
                        setIsResendAvailable(true);
                        setIsOtpInvalid(false);
                        setOtp("")
                      }}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <CustomButton
          type="button"
          text="Continue"
          width="100%"
          height="48px"
          background="#EBA832"
          onClick={handleButtonClick}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default OTPForm;